import styled from "styled-components";
import { Color, Font, breakpoints, ColorDark } from "@/shared/Constants";

export const SeparatorLinksRecipesContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .containerAutoFlex {
    display: flex;
  }
  .links-recipes {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    overflow-x: scroll;
    flex-direction: row;
    padding: 16px 0px;
    border-top: 1px solid ${Color.greySeparator};
    border-bottom: 1px solid ${Color.greySeparator};
    ${breakpoints.phone} {
      padding: 10px 15px;
    }
    ${breakpoints.darkMode} {
      [data-theme="dark"] & {
        border-top: 1px solid ${ColorDark.greySeparator};
        border-bottom: 1px solid ${ColorDark.greySeparator};
      }
    }
  }
  button {
    border: none;
    background: none;
    cursor: pointer;
  }
  .links-recipes-title {
    display: flex;
    align-items: center;
    justify-content: center;
    border-right: 1px solid ${Color.grey777};
    gap: 12px;
    padding: 2px 0px;
    padding-right: 15px;
    text-wrap: nowrap;
    .links-recipes-title-text {
      ${Font.sansRegular}
      font-size: 14px;
      line-height: 18px;
      color: ${Color.grey};
      padding-bottom: 2px;
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
  }
  .links-recipes-title > div svg {
    color: #555 !important;
  }
  .links-recipes-items {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
    padding-left: 15px;
    ${breakpoints.tablet} {
      width: 100%;
      padding: 15px;
      justify-content: flex-start;
    }
    ${breakpoints.phone} {
      width: 100%;
      padding: 15px;
      justify-content: flex-start;
    }
    .links-recipes-link {
      ${Font.sansRegular}
      font-size: 14px;
      line-height: 18px;
      color: ${Color.grey};
      ${breakpoints.tablet} {
        text-wrap: nowrap;
      }
      ${breakpoints.phone} {
        text-wrap: nowrap;
      }
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          color: ${ColorDark.textLight};
        }
      }
    }
    .links-recipes-dot {
      width: 2px;
      height: 2px;
      aspect-ratio: 1;
      border-radius: 50%;
      background-color: ${Color.grey};
      ${breakpoints.darkMode} {
        [data-theme="dark"] & {
          background-color: ${ColorDark.textLight};
        }
      }
    }
    .links-recipes-dot:last-of-type {
      display: none;
    }
  }
  .food-card-container {
    top: 374px;
    left: 215px;
    width: 280px;
    height: 331px;
    position: absolute;
  }
`;
